import { noUiSlider } from '../../../lib';

let _updateSearch;

export default (updateSearch, sliderClass) => {
  _updateSearch = updateSearch;
  Array.from(document.querySelectorAll(sliderClass)).forEach((slider) => {
    const $slider = $(slider);
    const sliderName = $slider.attr('name') || new Date().toString();
    $slider.attr('name', sliderName);

    const stepValue = $slider.data('step') || 1;
    const marginValue = $slider.data('margin') || 1;
    let minValue = $slider.data('min') || 0;
    const maxValue = $slider.data('max') || 100;

    if (minValue >= maxValue)
    {
      minValue = 0;
    }

    const startMin = $slider.data('default-min') || minValue;
    const startMax = $slider.data('default-max') || maxValue;
    const start = [startMin, startMax];

    let $wrapper = $slider.closest('.product-search__filter-range-wrapper');
    if ($wrapper.length === 0) {
      $wrapper = $slider;
    }
    const $minValueLabel = $('.product-search__filter-range-value-min, .range-slider__value--min', $wrapper);
    const $maxValueLabel = $('.product-search__filter-range-value-max, .range-slider__value--max', $wrapper);

    const formatValue = (rawValue) => Math.floor(rawValue).toLocaleString();

    const rangeSlider = noUiSlider.create(slider, {
      start,
      connect: true,
      margin: marginValue,
      step: stepValue,
      range: {
        min: [minValue],
        max: [maxValue]
      }
    });

    rangeSlider.on('update', (values) => {
      $minValueLabel.find('span').text(formatValue(values[0]));
      $minValueLabel.find('input').val(parseInt(values[0], 10));
      $maxValueLabel.find('span').text(formatValue(values[1]));
      $maxValueLabel.find('input').val(parseInt(values[1], 10));
    });

    if (sliderName && updateSearch) {
      rangeSlider.on('change', (values) => {
        updateSearch({ [sliderName]: values.map(Math.floor) });
      });

      updateSearch({ [sliderName]: start });
    }
  });
};

//update criteria == false will prevent duplicate calls masterplan web services
export const updateSliderOptions = (name, options, updateCriteria ) => {
  const slider = document.querySelector(`.product-search__filter-range-slider[name="${name}"]`);
  if (slider && slider.noUiSlider) {
    const existingOptions = slider.noUiSlider.options;
    slider.noUiSlider.updateOptions({ ...existingOptions, ...options });
    
    if(updateCriteria === true)
    {
        //console.log("2 updateSliderOptions");
        _updateSearch({ [name]: options.start });
    }
  }
};


// helper ----------------------------------------------------------------------------------
// todo: convert to private
export const getRangeConfig = (key, products) => {
    const range = products.filter(product => product[key]).reduce((collection, product) => ({
        min: Math.min(collection.min, Math.floor(product[key])),
        max: Math.max(collection.max, Math.ceil(product[key]))
    }), { min: Infinity, max: 0 });

    if (range.min === range.max) {
        range.min -= 10;
        range.max += 10;
    }

    return {
        start: [range.min, range.max],
        step: 1,
        margin: 1,
        range: {
            min: [range.min],
            max: [range.max]
        }
    };
};